import React from 'react';
import useStore from '../../../../store';
import './DebugMenu.css';
import { FaInfoCircle } from 'react-icons/fa';

function DebugMenu() {
  const store = useStore();
  const { ref } = store;
  const { puzzle, work, info } = ref;
  const { state } = puzzle;

  const {
    initializePuzzle,
    autoPlacePercentage,
    autoPlaceAlmostAll,
    resetPlacement,
  } = puzzle.methods;

  const isInfoMenuVisible = useStore(s => s.isInfoMenuVisible);

  const { isInitialized, isLoading, pieces, placedPiecesCount, rows, cols } = state;

  const totalPieces = rows * cols;

  const handleAutoPlace10 = () => {
    if (!isInitialized || isLoading) return;
    const currentPlaced = placedPiecesCount || 0;
    const targetCount = Math.min(totalPieces, currentPlaced + Math.ceil(totalPieces * 0.1));
    if (currentPlaced >= totalPieces) return;
    const effectiveTargetCount = Math.max(currentPlaced + 1, targetCount);
    const percentageToPlace = (effectiveTargetCount / totalPieces) * 100;
    autoPlacePercentage(percentageToPlace);
  };

  const handleAutoPlace99 = () => {
    if (!isInitialized || isLoading) return;
    autoPlaceAlmostAll();
  };

  const handleReset = () => {
    if (!isInitialized || isLoading) return;
    resetPlacement();
  };

  const handleInitialize = () => {
      if (isLoading) return;
      initializePuzzle();
  }

  const handleToggleInfoMenu = () => {
    useStore.setState(state=>({isInfoMenuVisible: !state.isInfoMenuVisible}));
  }

  const canDebug = isInitialized && !isLoading;

  return (
    <div className="debug-menu">
      <button
        className={`debug-button info-toggle ${isInfoMenuVisible ? 'active' : ''}`}
        onClick={()=>{
          work.methods.saveUserSets({debugInfo: !info.user.debugInfo}); puzzle.methods.render()
        }}
        title={isInfoMenuVisible ? "Скрыть инфо-панель" : "Показать инфо-панель"}
      >
        <FaInfoCircle />
      </button>

      <button
          className="debug-button initialize"
          onClick={handleInitialize}
          disabled={isLoading}
          title={isInitialized ? "Переинициализировать пазл" : "Начать игру"}
      >
        {isInitialized ? "Ре-Инит" : "Начать"}
      </button>

      <button
          className="debug-button animation"
          onClick={
            ()=>{
              puzzle.startAnimation.finished = false;
              puzzle.config.showTray = false;
              handleInitialize();
            }
          }
          disabled={isLoading}
          title={"Анимация"}
      >
        {"Анимация"}
      </button>

      <button
          className="debug-button borders"
          onClick={
            ()=>{
              work.methods.saveUserSets({debugMode: !info.user.debugMode}); puzzle.methods.render()
            }
          }
          disabled={isLoading}
          title="Показать рамки"
      >
        Рамки
      </button>

      {isLoading && <span className="loading-indicator">Загрузка...</span>}

      {isInitialized && (
          <>
            <button
              className="debug-button autoplace"
              onClick={handleAutoPlace10}
              disabled={!canDebug || placedPiecesCount >= totalPieces}
              title="Расставить следующие ~10% пазлов"
            >
              +10%
            </button>
            <button
              className="debug-button autoplace-almost"
              onClick={handleAutoPlace99}
              disabled={!canDebug || placedPiecesCount >= totalPieces -1}
              title="Расставить все пазлы кроме одного"
            >
              99%
            </button>
            <button
              className="debug-button reset"
              onClick={handleReset}
              disabled={!canDebug || placedPiecesCount === 0}
              title="Вернуть все расставленные пазлы в лоток"
            >
              Сброс
            </button>
          </>
      )}
    </div>
  );
}

export default DebugMenu;